/*
  -----------------------------------------------------------
  WARNING: DO NOT MANUALLY MODIFY THIS FILE!
  FILE GENERATED USING THE MARKETS CLI SCRIPT.
  IF YOU NEED TO ADD, REMOVE OR MODIFY MARKETS PLEASE
  NAVIGATE TO PROJECT ROOT FOLDER AND RUN `yarn markets`.
  -----------------------------------------------------------
  */
export type Currency = "USD" | "GBP" | "CAD" | "CHF" | "EUR" | "ZAR" | "NZD";
export type RegionName = "United States Of America" | "Great Britain" | "Canada" | "Switzerland" | "Germany" | "South Africa" | "New Zealand" | "Spain" | "Portugal" | "Antarctica" | "Italy";
export enum Regions {
    US = "US",
    GB = "GB",
    CA = "CA",
    CH = "CH",
    DE = "DE",
    ZA = "ZA",
    NZ = "NZ",
    ES = "ES",
    PT = "PT",
    AQ = "AQ",
    IT = "IT"
}
export type RegionCode = "US" | "GB" | "CA" | "CH" | "DE" | "ZA" | "NZ" | "ES" | "PT" | "AQ" | "IT";
export enum RegionNames {
    US = "United States Of America",
    GB = "Great Britain",
    CA = "Canada",
    CH = "Switzerland",
    DE = "Germany",
    ZA = "South Africa",
    NZ = "New Zealand",
    ES = "Spain",
    PT = "Portugal",
    AQ = "Antarctica",
    IT = "Italy"
}
export enum RegionCurrencies {
    US = "USD",
    GB = "GBP",
    CA = "CAD",
    CH = "CHF",
    DE = "EUR",
    ZA = "ZAR",
    NZ = "NZD",
    ES = "EUR",
    PT = "EUR",
    AQ = "EUR",
    IT = "EUR"
}
export type Brands = "bk" | "plk" | "th";
export type LanguageCode = "en" | "fr" | "de" | "es" | "pt" | "it";
export type LanguageName = "English" | "French" | "German" | "Spanish" | "Portuguese" | "Italian";
export type LocaleCode = "en-US" | "en-GB" | "en-CA" | "fr-CA" | "en-CH" | "de-CH" | "de-DE" | "en-ZA" | "en-NZ" | "es-ES" | "pt-PT" | "it-IT";
export interface IMarket {
    regionCode: RegionCode;
    regionName: RegionName;
    regionCurrency: Currency;
    regionBrands: Brands[];
    regionLanguages: IMarketLanguage[];
}
export interface IMarketLanguage {
    languageCode: LanguageCode;
    languageLocale: LocaleCode;
    languageName: LanguageName;
}
export const MARKETS: IMarket[] = [{ regionCode: "US", regionName: "United States Of America", regionCurrency: "USD", regionBrands: ["bk"], regionLanguages: [{ languageCode: "en", languageLocale: "en-US", languageName: "English" }] }, { regionCode: "GB", regionName: "Great Britain", regionCurrency: "GBP", regionBrands: ["bk"], regionLanguages: [{ languageCode: "en", languageLocale: "en-GB", languageName: "English" }] }, { regionCode: "CA", regionName: "Canada", regionCurrency: "CAD", regionBrands: [], regionLanguages: [{ languageCode: "en", languageLocale: "en-CA", languageName: "English" }, { languageCode: "fr", languageLocale: "fr-CA", languageName: "French" }] }, { regionCode: "CH", regionName: "Switzerland", regionCurrency: "CHF", regionBrands: ["plk", "bk"], regionLanguages: [{ languageCode: "en", languageLocale: "en-CH", languageName: "English" }, { languageCode: "de", languageLocale: "de-CH", languageName: "German" }] }, { regionCode: "DE", regionName: "Germany", regionCurrency: "EUR", regionBrands: ["bk"], regionLanguages: [{ languageCode: "de", languageLocale: "de-DE", languageName: "German" }] }, { regionCode: "ZA", regionName: "South Africa", regionCurrency: "ZAR", regionBrands: ["bk"], regionLanguages: [{ languageCode: "en", languageLocale: "en-ZA", languageName: "English" }] }, { regionCode: "NZ", regionName: "New Zealand", regionCurrency: "NZD", regionBrands: ["bk"], regionLanguages: [{ languageCode: "en", languageLocale: "en-NZ", languageName: "English" }] }, { regionCode: "ES", regionName: "Spain", regionCurrency: "EUR", regionBrands: ["bk", "plk"], regionLanguages: [{ languageCode: "es", languageLocale: "es-ES", languageName: "Spanish" }] }, { regionCode: "PT", regionName: "Portugal", regionCurrency: "EUR", regionBrands: ["bk"], regionLanguages: [{ languageCode: "pt", languageLocale: "pt-PT", languageName: "Portuguese" }] }, { regionCode: "AQ", regionName: "Antarctica", regionCurrency: "EUR", regionBrands: ["th"], regionLanguages: [{ languageCode: "en", languageLocale: "en-GB", languageName: "English" }] }, { regionCode: "IT", regionName: "Italy", regionCurrency: "EUR", regionBrands: ["plk"], regionLanguages: [{ languageCode: "it", languageLocale: "it-IT", languageName: "Italian" }] }];
export const LOCALES: LocaleCode[] = ["en-US", "en-GB", "en-CA", "fr-CA", "en-CH", "de-CH", "de-DE", "en-ZA", "en-NZ", "es-ES", "pt-PT", "it-IT"];
export const LANGUAGE_CODES: LanguageCode[] = ["en", "fr", "de", "es", "pt", "it"];
export const CURRENCIES: Currency[] = ["USD", "GBP", "CAD", "CHF", "EUR", "ZAR", "NZD"];
export const REGIONS: RegionCode[] = ["US", "GB", "CA", "CH", "DE", "ZA", "NZ", "ES", "PT", "AQ", "IT"];
export const REGION_NAMES: RegionName[] = ["United States Of America", "Great Britain", "Canada", "Switzerland", "Germany", "South Africa", "New Zealand", "Spain", "Portugal", "Antarctica", "Italy"];
export const BRANDS: Brands[] = ["bk", "plk", "th"];
